export const MODIFY_ANALYTICS_ID = 'MODIFY_ANALYTICS_ID';

export function modifyAnalyticsID(analyticsID){
    return{
        type: MODIFY_ANALYTICS_ID,
        mainState: {
            analyticsID: analyticsID
        }
    }
}